import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './../../../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { NotificationServiceService } from './../../../../../../../../../services/notification-service/notification-service.service';
import { ContenedoresService } from './../../../../../../../../../services/API/contenedores/contenedores.service';

@Component({
    selector: 'app-view-foto',
    templateUrl: './view-foto.component.html',
    styleUrls: ['./view-foto.component.css'],
    standalone: false
})
export class ViewFotoComponent implements OnInit {

  loadingBar: boolean = false;
  tipo: string = "";
  id: number;
  foto: string = "";
  fecha: string = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog, private ContenedoresService: ContenedoresService, private notificationService: NotificationServiceService, private dialogRef: MatDialogRef<ViewFotoComponent>) { }

  ngOnInit(): void {
    this.tipo = this.data['tipo'];
    this.id = parseInt(this.data['id']);
    this.foto = this.data['foto'];
    this.fecha = this.data['fecha'];
  }

  close() {
    this.dialogRef.close();
  }

  deleteImage(){
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: "Eliminar imagen", body: "¿Seguro que quieres borrar la imagen?"},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.loadingBar = true;
        this.ContenedoresService.deleteImage(this.tipo, this.id).subscribe(() => {
          this.loadingBar = false;
          this.notificationService.openSnackBar("Imagen eliminada correctamente.");
          this.dialogRef.close('delete');
        }, error => {
          this.loadingBar = false;
          this.notificationService.openSnackBar("❌ Se ha producido un error.");
        });
      }
    });
  }

}
